import { json } from "react-router-dom";
import api_adm from "./api";
const endpoint = "volontariat/SousDomaineCompetence";

export const SousDomaineService = {
  async lister(filtre) {
    try {
      const result = await api_adm.get(endpoint + "/liste", {
        params: { filtre: filtre },
      });
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async insert(filtre) {
    try {
      const result = await api_adm.post(endpoint + "/insert", filtre);
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async update(filtre) {
    try {
      const result = await api_adm.post(endpoint + "/update", filtre);
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async delete(filtre) {
    try {
      const result = await api_adm.post(endpoint + "/delete", filtre);
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async find_one(filtre) {
    try {
      const result = await api_adm.get(endpoint + "/find_one", {
        params: { filtre },
      });
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
};
